// @flow
import Generator from './Generator';

export default Generator;